module.exports = __webpack_public_path__ + "static/media/1_6.f6bbd1ac.png";